const state = {
    visit_purpose: [],  
    pendingVisitors: []
  }
  
  const getters = {}
  
  const actions = {
    getVisitPurposes ({ commit }) {
      axios
        .get("/admin/gate-visitpurposes")
        .then(response => (commit('setVisitPurpose', response.data)));
    },
    updateVisitStatus ({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .put("/admin/gate-update-visit-status", params, {
              headers: {
                'Content-Type': 'application/json',
              }
            })
          .then(response => {resolve(response)})
          .catch ( error => (reject(error)));
      })
    },
    getEntryVisitors ({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post("/admin/gate-visitors-entry-report", params , {
              headers: {
                'Content-Type': 'application/json',
              }
            })
          .then(response => {resolve(response)})
          .catch ( error => (reject(error)));
      })
    },    
    getPendingVisitors ({ commit }) {
      axios
        .get("/admin/gate-pending-visitors")
        .then(response => (commit('setPendingVisitors', response.data)));
    },
    createVisit ({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .put("/admin/gate-visit", params, {
              headers: {
                'Content-Type': 'application/json',
              }
            })
          .then(response => {resolve(response)})
          .catch ( error => (reject(error)));
      })
    },
  }
  
  const mutations = {
    setVisitPurpose (state, data) {
      state.visit_purpose = data.data;
    }, 
    setPendingVisitors(state, data){
      state.pendingVisitors = data.data;
    }
  
  
  
  }
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }
  